export default "__VITE_ASSET__BP2ZTIlL__"